import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import Heading from "components/Heading";
import SearchAside from "components/SearchAside";

import Popular from "./Popular";
import StudyPlaces from "./StudyPlaces";
import FeaturedPresentations from "./Featured";
import Seo from "components/Seo";
import { ScrollToTop } from "components/ScrollToTop";
import { useSection } from "hooks/section";

export default function Section() {
    const { sectionName, sectionUrl } = useSection();

    const title = `${sectionName} - Utbildningssidan`;

    return (
        <>
            <Seo title={title} />
            <ScrollToTop />
            <Container fluid>
                <Heading />
                <SearchAside showResults={true} adCache={false}>
                    <Row>
                        <Col md={6} xs={12}>
                            <Popular />
                        </Col>
                        <Col md={6} xs={12}>
                            <StudyPlaces />
                            <FeaturedPresentations />
                        </Col>
                    </Row>
                </SearchAside>
            </Container>
        </>
    );
}
